import cn from 'bem-cn';

import { Stack } from '../../UI';

import type { ChallengeInfoBodyProps } from './ChallengeInfoBody.types';
import { ChallengePrizes } from './ChallengePrizes';
import { ChallengeRequirements } from './ChallengeRequirements';
import { ChallengeCriterias } from './ChallengeCriterias';
import { ChallengeChecklist } from './ChallengeChecklist';
import './ChallengeInfoBody.scss';

const b = cn('challenge-info-body');

export const ChallengeInfoBody = (props: ChallengeInfoBodyProps) => {
    const { requirements, checklist, prizes, criterias, isCharity } = props.challenge;

    return (
        <Stack className={b()}>
            <ChallengePrizes prizes={prizes} isCharity={isCharity} />
            <ChallengeRequirements requirements={requirements} />
            <ChallengeCriterias criterias={criterias} />
            <ChallengeChecklist checklist={checklist} />
        </Stack>
    );
};
